module.exports = __webpack_public_path__ + "info_notify.png?78390835df0c7fbe8b377ea9311ed355";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info_notify.png
// module id = 966
// module chunks = 2